import { render, staticRenderFns } from "./BranchInformation.vue?vue&type=template&id=580f8279&scoped=true&"
import script from "./BranchInformation.vue?vue&type=script&lang=js&"
export * from "./BranchInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580f8279",
  null
  
)

export default component.exports